import React, {useState, useContext} from 'react';
import {
  CartesianGrid, ReferenceArea,
  ResponsiveContainer, Tooltip,
  XAxis, YAxis, AreaChart, Area, BarChart, Bar
} from "recharts";
import moment from "moment/moment";
import {ZoomContext} from "../contexts/ZoomContext";

const tickLookup = [3600*1000*24*182, 3600*1000*24*63, 3600*1000*24*30, 3600*1000*24*14, 3600*1000*24*7, 3600*1000*24*2, 3600*1000*24, 3600*1000*12, 3600*1000*8, 3600*1000*6, 3600*1000*4, 3600*1000*3, 3600*1000*2, 60*60*1000, 45*60*1000, 30*60*1000, 20*60*1000, 10*60*1000, 5*60*1000, 2*60*1000, 60*1000, 40*1000, 30*1000, 20*1000, 10*1000, 5*1000, 4*1000, 2*1000, 1000, 500, 200, 100, 50];

const SmartPlugSideBarChart = ({device, data, formattedData, metadata, metadataName, seriesName, unit, unitLong, stroke, onDragZoom, containerHeight}) => {
  // const [ticks, setTicks] = useState([]);
  // const [ticksPower, setTicksPower] = useState([]);
  // const [isPowerEnabled, setIsPowerEnabled] = useState(true);
  const [refAreaLeft, setRefAreaLeft] = useState('');
  const [refAreaRight, setRefAreaRight] = useState('');
  const { since, until } = useContext(ZoomContext);
  const zoomIntervalMillis = until - since;
  containerHeight = containerHeight || "100%";
  // console.log("Creating SmartPlugSideChart, device", device.toObject(), zoomIntervalMillis, new Date(since),"<->", new Date(until));

  const samples = data;
  // console.log("Side chart received", samples.length, "measurements for device",
  //     device.getId());
  const [linearDomainMin, linearDomainMax] = [since, until];
  // const linearScale = scaleLinear().domain([linearDomainMin, linearDomainMax]);
  // console.log("linear domain min/max", linearDomainMin, linearDomainMax);
  const durationMillis = linearDomainMax - linearDomainMin;
  const tickInterval = durationMillis / 3;
  // console.log("tick Interval", tickInterval);

  var modInterval = (durationMillis/(24*3600*1000)) > 370
      ? 180*24*3600*1000
      : (durationMillis/(24*3600*1000)) > 190
        ? 60*24*3600*1000
        : (durationMillis/(24*3600*1000)) > 65
          ? 30*24*3600*1000
          : (durationMillis/(24*3600*1000)) > 15
            ? 7*24*3600*1000
            : (durationMillis/(24*3600*1000)) > 2
              ? 24*3600*1000 : 3600*1000;//tickLookup.find((e) => tickInterval / 8 >= e);
  var selectedInterval = modInterval; //tickLookup.find((e) => tickInterval >= e);
  // console.log("selected interval", selectedInterval, "modInterval", modInterval);

  var start = linearDomainMin - (linearDomainMin % modInterval);
  var end = linearDomainMax;
  var tickValues = [];
  var i = start;
  for (i = start; i < end; i += selectedInterval) {
    tickValues.push(i);
  }

  let [minW, maxW] = [0, 1];
  const seriesMetadata = metadata;
  if (samples.length > 0) {

    const centiwattsMetadata = seriesMetadata.get(metadataName);
    // console.log("Bucketed Metadata for metadataName", metadataName, "is", centiwattsMetadata);
    if (centiwattsMetadata) {
      [minW, maxW] = [Math.min(minW, centiwattsMetadata.getSeriesMin()),
        Math.max(maxW, centiwattsMetadata.getSeriesMax())];
      // console.log("Bucketed metadata min/max", metadataName, minW, maxW);
    }
  }

  var tickPowerValues = [];
  start = minW - (minW % 5);
  end = (maxW + 5) - (maxW % 5);
  const increment = end-start/20;
  // console.log("Creating power values from start", start, "end", end);
  for (i = start; i <= end; i += increment) {
    tickPowerValues.push(i);
  }

  // console.log("Bar chart tickValues", tickValues, "tickPowerValues", tickPowerValues);
  // setTicks(tickValues);
  // setTicksPower(tickPowerValues);

  // console.log(linearScale.ticks(12))

  const zoom = () => {
    let left = refAreaLeft;
    let right = refAreaRight;
    console.log("zoom refAreaLeft", left, "refAreaRight", right);

    // Check if click but didn't drag
    if (left === right || right === '' || !left || !right) {
      setRefAreaLeft('');
      setRefAreaRight('');
      return;
    }

    let percent = Math.abs(Number(right)-Number(left)) / Math.abs(until-since)
    if (percent < 0.02) {
      console.log("Percent", percent, "Too small a percent for zoom, ignoring zoom request");
      setRefAreaLeft('');
      setRefAreaRight('');
      return;
    }

    // xAxis domain
    if (left > right) {
      // user dragged from right to left, swap around so left is always less than right
      [left, right] = [right, left];
    }

    // Reset to hide drag highlight now that mouse up has happened
    setRefAreaLeft('');
    setRefAreaRight('');

    console.log("Percent", percent, "Old since and until", since, until,
        "New since and until", left, right, new Date(left), new Date(right));
    // setIsLoadingChart(true);
    onDragZoom(left, right);
  }

  // const onLegendClick = (e) => {
  //   // Toggle opposite series such that clicking on the legend focuses on that series
  //   if (e.target.name === "humidity-legend") {
  //     setIsPowerEnabled(!isPowerEnabled);
  //   }
  // };

  const tickXFormatter = (unixTime) => {
    if (zoomIntervalMillis >= 604800000) { // 1 week
      return moment(unixTime).utc().format('M/DD')
    } else if (zoomIntervalMillis >= 129600000) { // 36 hours
      return moment(unixTime).format('MM/DD h:mma');
    } else if (zoomIntervalMillis >= 360000) { // 6 minutes
      return moment(unixTime).format('h:mma');
    } else {
      return moment(unixTime).format('h:mm:ssa');
    }
  }

  const tickYPowerFormatter = (value) => value.toFixed(2);

  const tickYHumidityFormatter = (value) => value.toFixed(2);

  const tickYDollarsFormatter = (value) => value.toFixed(2);

  const tickYDollarsCentsFormatter = (value) => value.toFixed(2);

  const tickYFormatter = (seriesName === "hourlydollars")
      ? tickYDollarsFormatter
      : tickYPowerFormatter

  const tooltipValuesFormatter = (value, name) => (name === "Time")
      ? moment(value).format('MMM DD, h:mm:ss a')
      : (Math.round(value * 100) / 100).toFixed(2);

  const tooltipFormatter = (seriesName === "hourlydollars")
      ? tickYDollarsCentsFormatter
      : tooltipValuesFormatter;


  const tooltipDateFormatter = (label, payload) => (label)
      ? (zoomIntervalMillis >= 39*604800000 ? moment(label).format('MMM DD, YYYY h:mm:ss a') : moment(label).format('MMM DD, h:mm:ss a'))
      : label;

  return (
      <>
      {formattedData.length > 0 &&
        <ResponsiveContainer width='100%' height={containerHeight}>
          <BarChart data={formattedData} barSize="1%"
                    responsive
                     onMouseDown={(e) => e && setRefAreaLeft(e.activeLabel)}
                     onMouseMove={(e) => e && refAreaLeft && setRefAreaRight(e.activeLabel)}
                     onMouseUp={(e) => zoom()}
                     margin={{
            top: 10,
            right: 10,
            bottom: 10,
            left: 0,
          }}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis
                dataKey='timestamp'
                domain={([dataMin, dataMax]) => { const offset = zoomIntervalMillis / 50; return [dataMin - offset, dataMax + offset]; }}
                name='Time'
                ticks={tickValues}
                tickFormatter={tickXFormatter}
                type='number'
            />
            <YAxis yAxisId="0" orientation="left"
                   tickFormatter={tickYFormatter}
                   name={{unitLong}} unit={unit}/>

            <Bar
                data={formattedData}
                dataKey={seriesName}
                width="auto"
                animationDuration={500}
                fill={stroke}
                stroke={stroke}
                dot={false}
                yAxisId="0"
                name={unitLong}
                type="stepAfter"
                unit={unit}
            />

            {refAreaLeft && refAreaRight ? (
                <ReferenceArea yAxisId="0" x1={refAreaLeft} x2={refAreaRight} strokeOpacity={0.3} />
            ) : null}

            <Tooltip
                offset={30}
                formatter={tooltipFormatter}
                labelFormatter={tooltipDateFormatter}
            />
          </BarChart>
        </ResponsiveContainer>
      }
      </>
  );
};

export default SmartPlugSideBarChart;

